export type ReviewDiffChangeType = "added" | "removed" | "modified";

export type ReviewDiffCellDetail = {
  before: string | null;
  after: string | null;
};

export type ReviewDiffSideInfo = {
  changeType: ReviewDiffChangeType;
  diffFieldPaths: string[];
  cellDiffs: Record<string, ReviewDiffCellDetail>;
};

export type ReviewDiffRowInfo = {
  src?: ReviewDiffSideInfo;
  dst?: ReviewDiffSideInfo;
};

export type GetIfDefinitionReviewDiffsResponse = {
  dfnSetVerNum: string;
  project: {
    pjtId: string;
  };
  compareTargetType:
    | "PREV_REVIEW"
    | "LATEST_STG"
    | "LATEST_PRD"
    | "PJ_START_STG"
    | "PJ_START_PRD";

  byIfReqId: Record<string, ReviewDiffRowInfo>;
};
